import React, {Component} from 'react'
import images from '../../config/images'
import { Header } from './styles'
import {checkMobile} from '../../lib'

class AppBar extends React.Component{
    render(){
        //const {component: Component, ...rest} = this.props
        return(
            <Header className="pr3 pl3"
                style={{zIndex: 100,background:'#ffffff95',position:'absolute'}}
                title={
                    <div className= {checkMobile ? 'h-100 flex justify-around flex-column' : 'h-100 pl3 flex justify-around flex-column'}>
                        <img src={images.fvlite_auto_trial_logo} alt="logo" style={{width: checkMobile() ? 220 : 310, cursor: 'pointer'}}
                    onClick={() => {window.open('https://www.freshvoice.net/lite/')}}/>
                    </div>
                }
                showMenuIconButton={false}
            />
        )
    }
}


export default AppBar



// WEBPACK FOOTER //
// src/layouts/LoggedOut/AppBar.js